import { MaterialService } from './material.service';
import { Lilate } from './../model/lilate.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Occurrence } from '../model/occurrence.model';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class OnlineMeetingsService extends KiwixiService {

    api_occurrences = environment.server + 'occurrences/generate_online_meetings/';
    api_lilates = environment.server + 'lilate_exams/generate_online_meetings/';

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    generateOccurrenceOnlineMeetings(occurrence: Occurrence): Observable<Occurrence> {
        const header = this.createHttpClientAuthorizationHeader();
        const url = this.api_occurrences + occurrence.id + '/';
        return this._http.get<Occurrence>(url, {
            headers: header
        })
            .pipe(
                catchError(this.handleErrorObservable<Occurrence>(`generateOccurrencesOnlineMeetings`))
            );
    }

    generateLilateOnlineMeetings(lilate: Lilate): Observable<Lilate> {
        const header = this.createHttpClientAuthorizationHeader();
        const url = this.api_lilates + lilate.id + '/';
        return this._http.get<Lilate>(url, {
            headers: header
        })
            .pipe(
                catchError(this.handleErrorObservable<Lilate>(`generateLilateOnlineMeetings`))
            );
    }
}
